const linkInvitationUserCopiedToClipboard = {
  toastr: 'Link',
  toastr1: 'Link copiado para a área de transferência'
};

export default linkInvitationUserCopiedToClipboard;